import { z } from 'zod'
import type { Occasion, OccasionId } from '@/schemas/occasion.schema'
import { occasionSchema } from '@/schemas/occasion.schema'

const rawOccasions = [
  {
    id: 'aniversario',
    title: 'Aniversário',
    emotionalHeadline:
      'Um jardim inteiro para celebrar mais um ano de quem você ama',
    description:
      'Arranjos e buquês que transformam a data em memória, do primeiro parabéns à última vela apagada.',
    conciergeSubcopy:
      'Conte quem faz aniversário e o que essa pessoa significa — a gente transforma a história em flor.',
    seoTitle: 'Flores para Aniversário — Flora Ateliê',
    seoDescription:
      'Buquês e arranjos de aniversário com entrega em toda a cidade. Flora Ateliê — encomende por e-mail e receba com todo cuidado.',
  },
  {
    id: 'namorados',
    title: 'Dia dos Namorados',
    emotionalHeadline: 'A prova viva de que o amor ainda escreve poesia',
    description:
      'Buquês que carregam o que as palavras não alcançam, criados para o dia em que declarar o óbvio nunca é demais.',
    conciergeSubcopy:
      'Conte como vocês se conheceram e o que você ainda não disse — a gente escreve o resto em pétalas.',
    seoTitle: 'Flores para Dia dos Namorados — Flora Ateliê',
    seoDescription:
      'Buquês para Dia dos Namorados com entrega em toda a cidade. Flora Ateliê — encomende por e-mail e surpreenda quem você ama.',
  },
  {
    id: 'casamento',
    title: 'Casamento',
    emotionalHeadline:
      'O buquê que testemunha o começo de uma história para sempre',
    description:
      'Do buquê da noiva aos arranjos das mesas, flores que acompanham cada instante, da entrada na cerimônia ao último brinde.',
    conciergeSubcopy:
      'Conte a data, o lugar e o sonho — a gente desenha o projeto floral do seu grande dia.',
    seoTitle: 'Flores para Casamento — Flora Ateliê',
    seoDescription:
      'Arranjos e buquês de casamento com entrega em toda a cidade. Flora Ateliê — escreva para o ateliê e monte o projeto floral do seu grande dia.',
  },
  {
    id: 'maternidade',
    title: 'Maternidade',
    emotionalHeadline: 'Dê boas-vindas ao amor que acabou de chegar',
    description:
      'Arranjos delicados para celebrar quem chegou e quem se tornou mãe, entregues no quarto do hospital ou na porta de casa.',
    conciergeSubcopy:
      'Conte o nome do bebê e onde a família está — a gente leva a delicadeza até o quarto.',
    seoTitle: 'Flores para Maternidade — Flora Ateliê',
    seoDescription:
      'Flores de maternidade com entrega em toda a cidade. Flora Ateliê — encomende por e-mail e celebre a chegada do bebê com todo carinho.',
  },
  {
    id: 'condolencias',
    title: 'Condolências',
    emotionalHeadline: 'Uma última homenagem à altura de quem você ama',
    description:
      'Coroas e arranjos de condolências entregues com discrição e cuidado, um gesto de conforto para quem enfrenta a despedida.',
    conciergeSubcopy:
      'Cuidamos de cada detalhe com discrição e respeito — você só precisa nos dizer para quem e onde.',
    seoTitle: 'Flores para Condolências — Flora Ateliê',
    seoDescription:
      'Coroas e arranjos de condolências com entrega em toda a cidade. Flora Ateliê — escreva para o ateliê para uma entrega rápida e respeitosa.',
  },
  {
    id: 'corporativo',
    title: 'Corporativo',
    emotionalHeadline: 'As flores que chegam antes do aperto de mão',
    description:
      'Arranjos institucionais para inaugurações, reuniões e presentes corporativos que representam sua marca com a elegância que ela exige.',
    conciergeSubcopy:
      'Conte o evento, a marca e quem vai receber — a gente monta arranjos à altura da sua empresa.',
    seoTitle: 'Flores para Ocasiões Corporativas — Flora Ateliê',
    seoDescription:
      'Arranjos corporativos com entrega em toda a cidade. Flora Ateliê — encomende por e-mail e leve sofisticação a qualquer evento de empresa.',
  },
  {
    id: 'sem-motivo',
    title: 'Sem Motivo',
    emotionalHeadline: 'Porque nem todo carinho precisa de data marcada',
    description:
      'Flores para um dia comum que merece deixar de ser comum, entregues só porque alguém pensou em alguém.',
    conciergeSubcopy:
      'Conte só o nome e o sorriso que você quer abrir hoje — a surpresa fica por nossa conta.',
    seoTitle: 'Flores Sem Motivo — Flora Ateliê',
    seoDescription:
      'Flores para presentear sem motivo, com entrega em toda a cidade. Flora Ateliê — encomende por e-mail e surpreenda hoje mesmo.',
  },
] as const

export const OCCASIONS: Occasion[] = z.array(occasionSchema).parse(rawOccasions)

export function findOccasionById(id: OccasionId): Occasion | undefined {
  return OCCASIONS.find((occasion) => occasion.id === id)
}
